import {Directive} from '@angular/core';

@Directive({
    selector: '[table-header-right-block]'
})
export class TableHeaderRightBlockDirective {
}
